import { addons } from '@storybook/addons';
import BshTheme from "./bsh-theme";

addons.setConfig({
	theme: BshTheme,
	staticDirs: ["../public"],
});
